import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Skills from "./Skills";

function About() {
	AOS.init();
	return (
		<div>
			<div className="content">
				<div className="inner">
					<div className="row">
						<div className="col-6">
							<h2>
								<span>About</span> Me.
							</h2>
							<p>
								I am a software engineer experienced in <span>frontend</span>{" "}
								and <span>backend</span> development. I have worn many hats in
								my career, including developer, team lead, and director. I am
								hyper-focused on providing pixel-perfect interfaces and clean,
								testable code.
							</p>
							<p>
								In the past, I've had the opportunity to work with companies
								large and small - from <span>advertising agencies</span> and{" "}
								<span>large corporations</span> like Netflix and The BBC to{" "}
								<span>start-ups</span> and <span>non-profits</span>.
							</p>
							<p>
								I have a passion for learning and teaching others. I am a
								self-starter and a problem solver. I am always looking for ways
								to improve my skills and the skills of those around me. Check
								out my{" "}
								<a
									href="https://www.youtube.com/@DevDrawer"
									target="_blank"
									rel="noopener noreferrer">
									YouTube channel
								</a>{" "}
								to see how I help other developers from around the world.
							</p>
						</div>
						<div className="col-6">
							<div className="aboutMeStats">
								<div className="row">
									<div className="col-12">
										<h3 style={{ textAlign: "center" }}>Experience</h3>
									</div>
								</div>
								<div className="row">
									<div className="col-12" style={{ textAlign: "center" }}>
										Over 18 years <em>(9 as director or senior)</em>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<h3 style={{ color: "#00a2ff", fontSize: "22px" }}>
											Programming Languages
										</h3>
									</div>
								</div>
								<div className="row">
									<div className="col-2">
										<strong>Backend</strong>
									</div>
									<div className="col-10">
										PHP, Node, VB, MySQL / MSSQL, MongoDB, NRQL
									</div>
								</div>
								<div className="row">
									<div className="col-2">
										<strong>Frontend</strong>
									</div>
									<div className="col-10">
										VanillaJS, React, TypeScript, Sass, HTML, MUI Framework
									</div>
								</div>
								<div className="row">
									<div className="col-2">
										<strong>Other</strong>
									</div>
									<div className="col-10">Git, Docker, CLI, Bash, SSH</div>
								</div>
								<div className="row">
									<div className="col-12">
										<h3 style={{ color: "#00a2ff", fontSize: "22px" }}>
											Personal Information
										</h3>
									</div>
								</div>
								<div className="row">
									<div className="col-4">
										<strong>Location</strong>
									</div>
									<div className="col-8">Atlanta, GA (proximity)</div>
								</div>
								<div className="row">
									<div className="col-4">
										<strong>Contact</strong>
									</div>
									<div className="col-8">
										<a href="mailto:eric@ericoliver.io">eric@ericoliver.io</a> /{" "}
										<a href="tel:228-219-9313">228-219-9313</a>
									</div>
								</div>
								<div className="row">
									<div className="col-4">
										<strong>Recommendations</strong>
									</div>
									<div className="col-8">
										<a
											href="https://www.linkedin.com/in/ericmarkoliver/details/recommendations/"
											target="_blank"
											rel="noopener noreferrer">
											View on LinkedIn
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<br />
					<br />
					<h2 className="h2Small text-center">Skillset</h2>
					<div className="row">
						<div className="col-12">
							<div className="row">
								<div className="col-6">
									<div className="card" data-aos="fade-up" data-aos-delay="100">
										<div className="card-body">
											<h3 className="text-center">Backend</h3>
											<p className="text-center">
												<strong>
													PHP, Node, VB, MySQL / MSSQL, MongoDB, NRQL
												</strong>
											</p>
											<p className="text-center">
												In PHP, I've engineered integrations, mentored
												developers, and created WordPress plugins. Proficiency
												in VB led to successful Windows solutions, enhancing
												brands and client satisfaction. Expertise in MSSQL and
												MySQL ensured efficient data management, reducing system
												downtime.
											</p>
										</div>
									</div>
								</div>
								<div className="col-6">
									<div className="card" data-aos="fade-up" data-aos-delay="100">
										<div className="card-body">
											<h3 className="text-center">Frontend</h3>
											<p className="text-center">
												<strong>
													VanillaJS, React, TypeScript, Sass, HTML, MUI
													Framework
													<br />
													Photoshop + Illustrator
												</strong>
											</p>
											<p className="text-center">
												With JavaScript, I've built interactive and dynamic user
												interfaces, leveraging the power of React to create
												scalable and feature-rich applications. Sass and HTML
												were instrumental in crafting visually appealing and
												responsive layouts.
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div className="card" data-aos="fade-up" data-aos-delay="200">
										<div className="card-body">
											<h3 className="text-center">Management</h3>
											<p className="text-center">
												<strong>
													Agile, Scrum, Jira, Project Management, Team
													Leadership
												</strong>
											</p>
											<p className="text-center">
												As a director, I've led teams, managed projects, and set
												a vision for the future. I've implemented Agile and
												Scrum methodologies, improving efficiency and
												collaboration. My leadership has fostered a culture of
												innovation and continuous improvement.
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<div className="card" data-aos="fade-up" data-aos-delay="200">
										<div className="card-body">
											<h3 className="text-center">Marketing</h3>
											<p className="text-center">
												<strong>SEO, SEM, Email Marketing, Content</strong>
											</p>
										</div>
									</div>
								</div>
								<div className="col-6">
									<div className="card" data-aos="fade-up" data-aos-delay="300">
										<div className="card-body">
											<h3 className="text-center">Server</h3>
											<p className="text-center">
												<strong>Git, Docker, CLI, Bash, SSH</strong>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<br />
					<div className="row" data-aos="fade-up">
						<div className="col-12 text-center">
							<p>
								Overall, I've driven growth, improved client satisfaction, and
								delivered quality solutions across industries and software
								languages.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default About;
